const initials = "userOrder/";
export const UPDATE_USER_ORDER_REDUCER = `${initials}UPDATE_USER_ORDER_REDUCER`;